module.exports = __webpack_public_path__ + "f7c15ab998f81add92692a6e7d7a1a58.png";